import Axios, { Response } from "../util/Axios";
import axios from 'axios';

export type LocationType = {
  lat: number;
  lng: number;
};

export type PositionContextType = {
  position: LocationType;
};

export type OrderType = {
  arrival_time: string;
  can_do_review: boolean;
  can_do_review_text: string;
  cancel_time: string;
  cancelled_at: string | null;
  confirmed_at: string | null;
  created_at: string | null;
  created_at_show: string;
  favorites_flag: number;
  days_left: number;
  lat: string;
  license_number: string;
  lng: string;
  msg_cancelled: string;
  msg_confirmed: string;
  msg_paid: string;
  msg_pickup: string;
  msg_prepared: string;
  options: [];
  order_id: number;
  payment_method: string;
  phone_number: string;
  picked_up_at: string | null;
  point_btn_txt: string;
  point_review: number;
  point_review_img: number;
  point_txt: string;
  prd_img_url: string;
  prd_list: OrderProductType[];
  prd_name_show: string;
  prepared_at: string | null;
  review_id: null;
  state_code: string;
  state_id: number;
  store_address: string;
  store_id: number;
  store_name: string;
  total_amount_excl: string;
  total_amount_incl: string;
  updated_at: string;
};
export type OrderProductType = {
  amount_tax_excl: string;
  amount_tax_incl: string;
  full_path: string;
  option_list: OrderOptionType[];
  order_detail_id: number;
  order_prd_key: string;
  prd_name: string;
  prd_price: string;
  prd_base_price: string;
  product_id: number;
  quantity: number;
  request_message: string;
  total_amount_excl: string;
  total_amount_incl: string;
  url_path: string;
};

export type OrderOptionType = {
  product_option_id: number;
  option_type_id: number;
  option_type_name: string;
  name: string;
  price: number;
  input_max: number;
  input_min: number;
};

export type AddressType = {
  address_name: string;
  mountain_yn: string;
  x: string;
  y: string;
};

export type CouponType = {
  condition: number;
  coupon_id?: number;
  end_date: string;
  expire_date: string;
  expired: number;
  max_discount: string;
  name: string;
  parent_coupon_id: number;
  percent: string;
  price: string;
  requirement: string;
  requirement_msg: string;
  show_content: string;
  show_date: string;
  show_name: string;
  start_date: string;
  store_id: number;
  type_id: number;
  used_packaged_coupon: number;
  user_coupon_id: number;
  stamp_coupon_id?: number;
  stamp_coupon_user_id?: number;
};

const UserController = {
  login: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/login";

      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[로그인 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  searchAddress: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/searchAddress";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[검색주소 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  dtDistance: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/dtDistance";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[목적지 기반 매장 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getPoints: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/getPoints";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[포인트 조회 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getCoupons: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/getCoupons";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[쿠폰 조회 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getStamps: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/getStamps";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[스탬프 조회 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getStampCoupons: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/user/getStampCoupons";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[스탬프 쿠폰 조회 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  getOrderAndArrivalTime: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/user/getOrderAndArrivalTime`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[매장 도착시간 호출 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  checkLoggedInWithQr: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/user/getList`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[QR 로그인 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  checkLoginPassword: async (oParams: any, sToken: string, sRefreshToken: string): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/obigo/user/checkLoginPassword`;
      const response: any = await axios.post(sUrl, oParams, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": sToken,
          "refresh-token": sRefreshToken,
        }
      })
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[QR 로그인 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  setUserShareType: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/user/setShareType`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[QR 로그인 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  setLoginPassword: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + `/obigo/user/setLoginPassword`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[QR 로그인 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
export default UserController;
